import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import styles from './Header.module.css';

interface Crumb {
  label: string;
  to?: string;
}

interface Props {
  breadcrumbs: Crumb[];
  title: React.ReactNode;
  subtitle?: string | null;
  meta?: React.ReactNode;
}

export function Header({ breadcrumbs, title, subtitle, meta }: Props) {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  return (
    <div className={styles.topbar}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.topRow}>
          <nav className={styles.breadcrumb}>
            {breadcrumbs.map((c, i) => {
              const isLast = i === breadcrumbs.length - 1;
              return (
                <span key={i}>
                  {isLast || !c.to ? (
                    <span className={styles.current}>{c.label}</span>
                  ) : (
                    <a onClick={() => navigate(c.to!)}>{c.label}</a>
                  )}
                  {!isLast && <span className={styles.sep}>/</span>}
                </span>
              );
            })}
          </nav>
          <div className={styles.userBox}>
            <span className={styles.userName}>{user?.name}</span>
            <button
              className={styles.logoutBtn}
              onClick={() => {
                logout();
                navigate('/login');
              }}
            >
              Salir
            </button>
          </div>
        </div>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        {meta && <div className={styles.meta}>{meta}</div>}
      </div>
    </div>
  );
}
